import React, { Component } from 'react'
import axios from 'axios'
import { Auth } from 'aws-amplify'

const COLUMNS = [
  { key: 'RSTips',     label: 'Tips'    },
  { key: 'RTW',        label: 'Rated to Win' },
  { key: 'R12M',       label: '12M'          },
  { key: 'L12',        label: 'SL12M'        },
  { key: 'CareerSR',   label: 'Career SR'    },
  { key: 'ForAgainst', label: 'For/Against'  },
]

const POINTS   = { 1: 3, 2: 2, 3: 1 }

const toTitleCase = str =>
  str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())
const RANK_COL = [
  { rank: 1, label: '1st', color: '#b8790a', bg: '#fff8ed', border: '#f5c96a' },
  { rank: 2, label: '2nd', color: '#5a7080', bg: '#f4f7f9', border: '#c0cdd6' },
  { rank: 3, label: '3rd', color: '#8c5020', bg: '#fdf5ef', border: '#e0b08a' },
]

const css = `
  .rm-wrap {
    font-family: inherit;
    background: #fff;
    border: 1px solid #cdd8e3;
    border-radius: 4px;
    overflow: hidden;
    margin-top: 4px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    max-width: 100%;
    box-sizing: border-box;
  }
  .rm-wrap * {
    box-sizing: border-box;
  }
  .rm-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1a5a8a;
    padding: 4px 8px;
  }
  .rm-title {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #fff;
  }
  .rm-subtitle {
    font-size: 9px;
    color: rgba(255,255,255,0.45);
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
  .rm-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  /* ── column header row (1st / 2nd / 3rd) ── */
  .rm-thead th {
    padding: 4px 6px;
    border-right: 1px solid #dde6ee;
    border-bottom: 2px solid #dde6ee;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .rm-thead th:first-child {
    background: #f0f5fa;
    color: #7a9ab5;
    width: 82px;
    text-align: left;
    border-right: 2px solid #cdd8e3;
  }
  /* ── criteria label column ── */
  .rm-crit-cell {
    background: #f0f5fa;
    border-right: 2px solid #cdd8e3 !important;
    border-bottom: 1px solid #dde6ee;
    padding: 0 !important;
    vertical-align: middle;
  }
  .rm-crit-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 7px;
    width: 100%;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    font-family: inherit;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    color: #2d6090;
    transition: background 0.12s;
    white-space: nowrap;
    overflow: hidden;
    min-width: 0;
  }
  .rm-crit-btn:hover   { background: #e2edf6; }
  .rm-crit-btn.inactive { color: #b8c8d5; }
  .rm-check {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    border: 1px solid currentColor;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 7px;
    flex-shrink: 0;
  }
  .rm-crit-btn.active .rm-check {
    background: #1a5a8a;
    border-color: #1a5a8a;
    color: #fff;
  }
  .rm-crit-btn.inactive .rm-check {
    background: transparent;
    border-color: #c5d3dc;
    color: transparent;
  }
  /* ── rank data cells ── */
  .rm-td {
    padding: 3px 6px;
    border-right: 1px solid #dde6ee;
    border-bottom: 1px solid #dde6ee;
    vertical-align: middle;
  }
  .rm-td.inactive-col { background: #f8fafb; }
  .rm-cell {
    display: flex;
    align-items: center;
    gap: 4px;
    min-height: 18px;
  }
  .rm-tab {
    font-family: inherit;
    font-size: inherit;
    font-weight: 600;
    flex-shrink: 0;
  }
  .rm-name {
    font-size: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1;
    line-height: 1;
  }
  .rm-name.inactive-col { color: #c0cdd6; }
  .rm-dash {
    font-family: inherit;
    font-size: 10px;
    color: #d8e2ea;
  }
  /* ── leaderboard ── */
  .rm-lb {
    background: #f4f8fb;
    border-top: 1px solid #cdd8e3;
    padding: 4px 8px;
  }
  .rm-lb-title {
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #9ab0bf;
    margin-bottom: 3px;
  }
  .rm-lb-rows { display: flex; flex-wrap: wrap; gap: 4px 10px; align-items: center; }
  .rm-lb-row  { display: flex; align-items: center; gap: 2px; white-space: nowrap; }
  .rm-lb-pos  {
    font-size: 10px;
    font-weight: 700;
    flex-shrink: 0;
    margin-right: 1px;
  }
  .rm-lb-tab  { font-size: 11px; font-weight: 700; flex-shrink: 0; }
  .rm-lb-name { font-size: 11px; font-weight: 600; color: #1a2d3d; }
  .rm-lb-pts  { font-size: 10px; font-weight: 700; margin-left: 2px; }
  .rm-loading {
    padding: 8px 10px;
    font-size: 10px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #9ab0bf;
    font-weight: 600;
  }
  .rm-dot { display: inline-block; animation: rm-blink 1.2s infinite; }
  .rm-dot:nth-child(2) { animation-delay: 0.2s; }
  .rm-dot:nth-child(3) { animation-delay: 0.4s; }
  @keyframes rm-blink {
    0%,80%,100% { opacity: 0.15; }
    40%         { opacity: 1; }
  }
`

const LB_COLORS = ['#b8790a', '#5a7080', '#8c5020', '#2d75af', '#9ab0bf']

class ComputerSelectionPanels extends Component {
  constructor(props) {
    super(props)
    const enabledColumns = {}
    COLUMNS.forEach(col => { enabledColumns[col.key] = true })
    this.state = { rankTableEntries: [], loading: false, error: null, enabledColumns }
  }

  componentDidMount() {
    if (this.props.bfMarketId) this.fetchData(this.props.bfMarketId)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.bfMarketId !== this.props.bfMarketId && this.props.bfMarketId) {
      this.fetchData(this.props.bfMarketId)
    }
  }

  async fetchData(bfMarketId) {
    this.setState({ loading: true, error: null, rankTableEntries: [] })
    try {
      const session = await Auth.currentSession()
      const token   = session.getIdToken().getJwtToken()
      const res     = await axios.get(
        `https://racematrixapi.makebettinggreat.com/v1/market/${bfMarketId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      const entries = res.data && res.data.rankTableEntries ? res.data.rankTableEntries : []
      this.setState({ rankTableEntries: entries, loading: false })
    } catch {
      this.setState({ rankTableEntries: [], loading: false, error: null })
    }
  }

  toggleColumn(colKey) {
    this.setState(prev => ({
      enabledColumns: { ...prev.enabledColumns, [colKey]: !prev.enabledColumns[colKey] }
    }))
  }

  getEntry(colKey, rank) {
    return this.state.rankTableEntries.find(e => e.column === colKey && e.rank === rank)
  }

  getAggregate() {
    const { enabledColumns } = this.state
    const totals = {}
    this.state.rankTableEntries
      .filter(e => e.rank <= 3 && enabledColumns[e.column])
      .forEach(e => {
        const pts = POINTS[e.rank] || 0
        if (!totals[e.horseName]) {
          totals[e.horseName] = { horseName: e.horseName, tabNumber: e.tabNumber, points: 0 }
        }
        totals[e.horseName].points += pts
      })
    return Object.values(totals).sort((a, b) => b.points - a.points)
  }

  render() {
    const { loading, rankTableEntries, enabledColumns } = this.state
    if (!this.props.bfMarketId) return null

    return (
      <div className="rm-wrap">
        <style>{css}</style>

        <div className="rm-header">
          <span className="rm-title">RaceMatrix</span>
          <span className="rm-subtitle">tap header to toggle</span>
        </div>

        {loading ? (
          <div className="rm-loading">
            Fetching<span className="rm-dot">.</span><span className="rm-dot">.</span><span className="rm-dot">.</span>
          </div>
        ) : rankTableEntries.length === 0 ? null : (
          <>
            <table className="rm-table">
              <thead className="rm-thead">
                <tr>
                  <th>Rank</th>
                  {COLUMNS.map(col => {
                    const active = enabledColumns[col.key]
                    return (
                      <th key={col.key} style={{ padding: 0 }}>
                        <button
                          className={`rm-crit-btn ${active ? 'active' : 'inactive'}`}
                          onClick={() => this.toggleColumn(col.key)}
                        >
                          <span className="rm-check">{active ? '✓' : ''}</span>
                          {col.label}
                        </button>
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {RANK_COL.map(rc => (
                  <tr key={rc.rank}>
                    <td className="rm-crit-cell">
                      <span className="rm-crit-btn" style={{ color: rc.color, cursor: 'default' }}>
                        {rc.label}
                      </span>
                    </td>
                    {COLUMNS.map(col => {
                      const active = enabledColumns[col.key]
                      const entry  = this.getEntry(col.key, rc.rank)
                      return (
                        <td key={col.key} className={`rm-td${active ? '' : ' inactive-col'}`}>
                          {entry ? (
                            <div className="rm-cell">
                              <span className="rm-tab">
                                {entry.tabNumber}.
                              </span>
                              <span className={`rm-name${active ? '' : ' inactive-col'}`}>
                                {toTitleCase(entry.horseName)}
                              </span>
                            </div>
                          ) : (
                            <span className="rm-dash">—</span>
                          )}
                        </td>
                      )
                    })}
                  </tr>
                ))}
              </tbody>
            </table>

            <LeaderBoard aggregate={this.getAggregate()} />
          </>
        )}
      </div>
    )
  }
}

function LeaderBoard({ aggregate }) {
  if (!aggregate.length) return null
  const maxPts = aggregate[0].points || 1
  return (
    <div className="rm-lb">
      <div className="rm-lb-title">Aggregate</div>
      <div className="rm-lb-rows">
        {aggregate.map((item, i) => {
          const color = LB_COLORS[Math.min(i, LB_COLORS.length - 1)]
          const pct   = Math.round((item.points / maxPts) * 100)
          return (
            <div className="rm-lb-row" key={item.horseName}>
              <span className="rm-lb-pos" style={{ color }}>#{i + 1}</span>
              <span className="rm-lb-tab">{item.tabNumber}.</span>
              <span className="rm-lb-name">{toTitleCase(item.horseName)}</span>
              <span className="rm-lb-pts" style={{ color }}>({item.points})</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ComputerSelectionPanels
